<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary">
            Session Resources
        </div>
    </div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="sessionResourceConfig.isResourceEnabled ? 'Enable' : 'Disable'"
            [isChecked]="sessionResourceConfig.isResourceEnabled"
            (isCheckedChange)="toggleResourceEnabled($event)"
            >{{ sessionResourceConfig.isResourceEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<ccl-content-section *ngIf="sessionResourceConfig.isResourceEnabled == true">
    <div class="resources-drawer">
        <div class="c-title--subsection text-uppercase">
            Drawer
        </div>
        <div class="row row--builder">
            <div class="col c-box" [class.c-box]="!hoverOut" [class.c-box-nohover]="hoverOut">
                <div
                    class="c-box" title="Edit Drawer Header"
                    (cclClick)="openConfigDrawer('header', $event, 'header')"
                    (mouseout)="hoverOut = false"
                    (mouseover)="hoverOut = true"
                >
                    <h3
                        class="resources-drawer-header"
                        [ngStyle]="{
                            background: sessionResourceConfig.header.background
                        }"
                    >
                        <span [ngStyle]="fontstyle">
                            {{ sessionResourceConfig.header.label }}
                        </span>
                    </h3>
                </div>
                
                <div class="resources-drawer-body c-box" title="Edit Drawer Body"
                    (mouseout)="hoverOut = false" 
                    (mouseover)="hoverOut = true">
                    <div class="col-sm-12 col-xs-12" 
                        (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                </div>
                <div class="resources-drawer-footer c-box" 
                    (mouseout)="hoverOut = false" 
                    (mouseover)="hoverOut = true">
                    <button
                        class="c-btn c-btn--primary"
                        [ngStyle]="{
                            'background-color': sessionResourceConfig.button.primary.background,
                            'color': sessionResourceConfig.button.primary.color
                        }"
                    >
                        <i class="fa fa-download fa-lg"></i>
                         Resources
                    </button>
                </div>
            </div>
        </div>
    </div>
</ccl-content-section>
